module.exports = __webpack_public_path__ + "static/media/thumb3.91220b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/thumb3.jpg
// module id = 372
// module chunks = 0